import { useContext } from 'react';

import LayoutEntity from '@models/LayoutEntity';

import LayoutEntityFilterContext, { LayoutEntityFilterValues } from './context';

function useLayoutEntityFilterContext<T extends LayoutEntity>(): LayoutEntityFilterValues<T> {
  return useContext(LayoutEntityFilterContext);
}

export default useLayoutEntityFilterContext;
